import React, { useState, useEffect } from "react";
import Splash2 from "./screen2";
import Splash3 from "./screen3";

import Splash5 from "./screen5";

export default function SplashShowcase({ onFinish }) {
  const opened_before = localStorage.getItem("splash_opened_before") === "true";
  const [index, setIndex] = useState(0);

  const splashScreens = opened_before
    ? [<Splash5 onFinish={handleFinish} />]
    : [
        <Splash2 />,
        <Splash3 />,

        <Splash5 onFinish={handleFinish} />,
      ];

  function handleFinish() {
    //localStorage.setItem("splash_opened_before", "true");

    if (onFinish) onFinish();
  }

  
{/* */}
  useEffect(() => {
    if (!opened_before && index < splashScreens.length - 1) {
      const timer = setTimeout(() => setIndex((prev) => prev + 1), 3000);
      return () => clearTimeout(timer);
    }
  }, [index, opened_before, splashScreens.length]);

  return <div className="position-relative">{splashScreens[index]}</div>;
}
